<template>
  <div class="mt-10">
    <v-row v-if="isMobile">
      <v-row>
        <v-col class="ml-5">
          <v-btn color="primary" class="primary-font-color" @click="goHome">
            {{ $translate('BACK') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row style="position: absolute; left: 50%; transform: translateX(-50%)">
        <v-col>
          <v-toolbar-title>{{ calendarTitle }}</v-toolbar-title>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="ml-5">
          <v-btn
            color="primary"
            class="primary-font-color"
            :disabled="isCurrentMonth"
            @click="$refs.calendar.prev()"
          >
            <v-icon dark left> keyboard_arrow_left </v-icon>
            {{ $translate('PREVIOUS') + ' ' + $translate('MONTH') }}
          </v-btn>
        </v-col>
        <v-col class="mr-5">
          <v-btn
            color="primary"
            class="primary-font-color"
            @click="$refs.calendar.next()"
          >
            {{ $translate('NEXT') + ' ' + $translate('MONTH') }}
            <v-icon right dark> keyboard_arrow_right </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-row>

    <v-row v-else align="center">
      <v-col cols="2" class="text-center">
        <v-btn color="primary" class="primary-font-color" @click="goHome">
          {{ $translate('BACK') }}
        </v-btn>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-btn
          color="primary"
          class="primary-font-color"
          :disabled="isCurrentMonth"
          @click="$refs.calendar.prev()"
        >
          <v-icon dark left> keyboard_arrow_left </v-icon>
          {{ $translate('PREVIOUS') + ' ' + $translate('MONTH') }}
        </v-btn>
      </v-col>

      <v-col cols="2" class="text-center">
        <v-toolbar-title>{{ calendarTitle }}</v-toolbar-title>
      </v-col>

      <v-col cols="5">
        <v-btn
          color="primary"
          class="primary-font-color"
          @click="$refs.calendar.next()"
        >
          {{ $translate('NEXT') + ' ' + $translate('MONTH') }}
          <v-icon right dark> keyboard_arrow_right </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-card height="500" class="ml-5 mr-5 mt-10">
      <v-calendar
  ref="calendar"
  v-model="events.StartDate"
  :events="events"
  :type="type"
  color="primary"
  @click:event="eventClick"
  :event-color="getEventColor"
>
  <template #event="{ event }">
    <div class="d-flex align-center">
        <v-img max-width="25px" :src="event.picture" />
      <span>{{ event.name }}</span>
    </div>
  </template>
</v-calendar>

    </v-card>
  </div>
</template>

<script>
import utility from '@/shared/utility';
import doRequest from '@/api/dssRequest';

export default {
  data() {
    return {
      type: 'month',
      events: [],
      unsortedEvents: [],
      calendarReady: false,
    };
  },
  name: 'Calendar',
  mounted() {
    this.getCalendar();
    this.calendarReady = true;
    window.scrollTo(0, 0);
  },
  computed: {
    userObjId() {
      return this.$store.getters['auth/userObjectId'];
    },
    calendarTitle() {
      return this.calendarReady ? this.$refs.calendar.title : '';
    },
    isCurrentMonth() {
      if (this.calendarReady) {
        const currentDate = new Date();
        const currentMonth = currentDate.toLocaleString('default', {
          month: 'long',
        });
        const currentYear = currentDate.getFullYear();
        return this.calendarTitle === `${currentMonth} ${currentYear}`;
      }
      return false;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getCalendar() {
      const startDateYMD = utility.getCurrentDateYMD();
      const endDate = utility.addDays(startDateYMD, 30 * 6);

      const payload = {
        StartDate: utility.getCurrentDateDMY(),
        EndDate: endDate,
        FullCalendar: true,
      };

      this.events = [];

      doRequest(
        (response) => {
          if (response.data.Calendar != null) {
            this.unsortedEvents = this.sortCalendar(response.data.Calendar);
            console.log(this.unsortedEvents);
            const sortedCalendar = this.sortCalendar(response.data.Calendar);
            this.events = sortedCalendar.map((event) => ({
              start: event.StartDate,
              startTime: event.StartTime,
              endTime: event.EndTime,
              name: event.StartTime + '-' + event.EndTime + '  ' + event.Name,
              location: event.LocationName,
              bookable: event.Bookable,
              eventId: event.EventId,
              picture: event.PictureUrl,
            }));
            this.events.forEach((event) => {
              event.start = event.start.split('-').reverse().join('-');
            });
          }
        },
        () => {},
        'getCalendar',
        this.userObjId,
        payload,
        'GET'
      );
    },
    sortCalendar(rawCalendar) {
      const sortedCalendar = [];

      Object.entries(rawCalendar).forEach(([dateStr, eventObjs]) => {
        Object.entries(eventObjs).forEach(([eventId, eventObj]) => {
          const dateYMDStr = utility.dateFromDMYToYMD(dateStr);
          const dateTimeStr = `${dateYMDStr} ${eventObj.StartTime}`;
          const dateObj = new Date(dateTimeStr);
          const activity = { ...eventObj };
          activity.Date = dateObj;
          activity.StartDate = dateStr;

          sortedCalendar.push(activity);
        });
      });

      sortedCalendar.sort((a, b) => a.Date.getTime() - b.Date.getTime());
      return sortedCalendar;
    },
    eventClick(event) {
      if (event.event.bookable) {
        const ymdDate = event.day.date;
        const dateObj = new Date(ymdDate);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        const dmyDate = `${day}-${month}-${year}`;

        this.$router.push({
          name: 'EventDetails',
          params: {
            event_id: event.event.eventId,
            event_date: dmyDate,
          },
        });
      }
    },
    goHome() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    getEventColor(event) {
      return event.bookable ? 'blue' : 'grey';
    },
  },
};
</script>
